import { BrowserCacheLocation, Configuration, LogLevel, RedirectRequest } from "@azure/msal-browser";
// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AUTH_CLIENTID as string,
    authority: `https://${process.env.REACT_APP_AUTH_NAME}.b2clogin.com/${process.env.REACT_APP_AUTH_NAME}.onmicrosoft.com/${process.env.REACT_APP_AUTH_PROFILE}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    knownAuthorities: [`${process.env.REACT_APP_AUTH_NAME}.b2clogin.com`],
    navigateToLoginRequestUrl: false,
  },
  cache: {
    storeAuthStateInCookie: false,
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Error,
    },
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: RedirectRequest = {
  scopes: [
    process.env.REACT_APP_AUTH_SCOPE_ADMIN as string,
    process.env.REACT_APP_AUTH_SCOPE_READ as string,
    process.env.REACT_APP_AUTH_SCOPE_WRITE as string,
  ],
};

export const forgotPasswordRequest = {
  authority: `https://${process.env.REACT_APP_AUTH_NAME}.b2clogin.com/tfp/${process.env.REACT_APP_AUTH_NAME}.onmicrosoft.com/${process.env.REACT_APP_AUTH_PROFILE_PASSWORD}`,
  scopes: [],
};
